import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import Swal from "sweetalert2";

import { ProfileService } from "../../../../../services";
import { User, Errors, Community } from "../../../../../models";

@Component({
  selector: "del-membership-auth-form",
  templateUrl: "./del-membership-auth-form.component.html",
  styleUrls: [
    "./del-membership-auth-form.component.scss",
    "../../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class DelMembershipAuthForm implements OnInit {
  @Input() currentUser: User;
  @Input() community: Community;
  public errors: Errors = new Errors();
  public isSubmitting: boolean = false;
  public authForm: FormGroup;

  constructor(
    private router: Router,
    private profileService: ProfileService,
    private fb: FormBuilder
  ) {
    // use FormBuilder to create a form group
    this.authForm = this.fb.group({
      email: ["", Validators.required],
      password: ["", Validators.required],
    });
  }

  ngOnInit() {}

  public attemptLocalAuth() {
    Swal.fire({
      title: "Delete?",
      text: "Deleting your membership will not delete your content. Delete content first to remove all your content",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Haai, cancel!",
      confirmButtonText: "Delete my membership!",
    }).then((result) => {
      if (result.value) {
        this.authorizeDeletion();
      }
    });
  }

  public deleteMembership() {
    this.isSubmitting = true;
    this.errors = new Errors();
    let credentials = this.authForm.value;

    this.profileService
      .deleteMembership(this.currentUser, this.community, credentials)
      .subscribe(
        (data) => {
          this.fireSuccessAlert();
          this.router.navigateByUrl("/communities");
        },
        (err) => {
          this.errors = err;
          this.isSubmitting = false;
          this.fireErrorAlert();
        }
      );
  }

  public authorizeDeletion() {
    Swal.fire({
      title: "Delete?",
      text: "Vele vele, this is goodbye " + this.currentUser.username + "?",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Haai, cancel!",
      confirmButtonText: "Delete my membership!",
    }).then((result) => {
      if (result.value) {
        this.deleteMembership();
      }
    });
  }

  public fireSuccessAlert() {
    Swal.fire({
      title: "Deleted",
      text: "Membership deleted",
      type: "success",
    });
  }

  public fireErrorAlert() {
    Swal.fire("Eish!", "There were errors with your deletion", "warning");

    function errorAlert() {
      Swal.close();
    }

    setTimeout(errorAlert, 3000);
  }
}
